<ng-container *ngIf="errors">
    <ng-container *ngIf="errors.length > 1">
        <ul class="styled-list m-0 pl-16">
            <li *ngFor="let error of errors">
                <div [class]="errorClasses">{{ error }}</div>
            </li>
        </ul>
    </ng-container>

    <ng-container *ngIf="errors.length == 1">
        <div [class]="errorClasses">{{ errors[0] }}</div>
    </ng-container>
</ng-container>